/**
 * Projekt-Speichern von einer Rechteprüfung der Datenbank abgewiesen — der
 * Satz für den Hinweisbalken (Rollensystem, docs/rollensystem-plan.md §11).
 *
 * Der Fall, für den es das gibt: der Trigger `w_projects_typ_wechsel_trg`
 * (Nr. 154) weist einen Typwechsel ohne das Anlegen-Recht des neuen Typs ab
 * („projects_typ_recht: fehlendes Recht projekte.sifa_anlegen“, 42501). Die
 * Warteschlange hält das für wiederholbar und zeigt still „Wartet auf Sync“ —
 * und solange der lokale Stand den Typ trägt, scheitert jeder weitere Versuch
 * genauso. Der Balken sagt, was los ist und was hilft.
 *
 * Alles andere ist hier kein Rechtefehler: dann null, und es bleibt beim
 * bisherigen Verhalten.
 */
import { rechtFehlerText } from './rechtFehler';

/** Die Meldung des Typ-Triggers (Nr. 154) — nur dort hilft das Zurückstellen. */
const TYP_TRIGGER = 'projects_typ_recht:';

/**
 * „Gespeichert wurde nicht: Dafür fehlt Ihnen das Recht „…“.“, beim
 * Typwechsel mit dem Hinweis, den Projekttyp zurückzustellen. `projekt`
 * (Nummer und Name) steht dabei, weil die Warteschlange auch Projekte
 * hochlädt, die gerade nicht offen sind.
 */
export const speicherRechtHinweis = (e: unknown, projekt?: string): string | null => {
    if (typeof e !== 'object' || e === null) return null;
    const fehler = e as { code?: string; message?: string };
    const satz = rechtFehlerText(fehler);
    if (!satz) return null;
    const wo = projekt ? ` (Projekt „${projekt}“)` : '';
    const rat = fehler.message?.includes(TYP_TRIGGER) ? ' Den Projekttyp bitte zurückstellen.' : '';
    return `Gespeichert wurde nicht${wo}: ${satz}${rat}`;
};

/**
 * Die Rechte-Hinweise eines Projekts entfernen, sobald es wieder gespeichert
 * werden konnte. Gibt es keinen, kommt DIESELBE Liste zurück — der Aufruf
 * hängt an jedem erfolgreichen Hochladen und soll dann keinen Render kosten.
 */
export const ohneRechtHinweisFuer = <T extends { rechtProjektId?: string }>(hinweise: T[], projektId: string): T[] =>
    hinweise.some(h => h.rechtProjektId === projektId)
        ? hinweise.filter(h => h.rechtProjektId !== projektId)
        : hinweise;
